import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=2be0d91e&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=2be0d91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0d91e",
  null
  
)

export default component.exports